(function () {
  'use strict';

  angular
    .module('app')
    .component('clientCommissionProductSettingList', clientCommissionProductSettingList());

  function clientCommissionProductSettingList() {
    return {
      bindings: {
        clientCommissionSeasonId: '=',
        clientId: '=',
        productSettings: '=',
        priceLists: '=',
        mode: '<',
        onProductSettingsUpdated: '&',
      },
      controller: ClientCommissionProductSettingComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/clients/components/product-settings/product-setting-list/product-setting-list.component.html',
    };
  }

  ClientCommissionProductSettingComponent.$inject = [
    'UtilService',
    'ClientCommissionProductSettingService',
    'TourService',
    'TransportationService',
    'HotelService',
    'ServiceItemService',
    'PackageService',
  ];

  function ClientCommissionProductSettingComponent(
    UtilService,
    ClientCommissionProductSettingService,
    TourService,
    TransportationService,
    HotelService,
    ServiceItemService,
    PackageService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.productTypes = vm.UtilService.getProductTypes();
    vm.productTypeLabel = 'SELECT';

    // Methods
    vm.addProductSettings = addProductSettings;
    vm.removeProductSettings = removeProductSettings;
    vm.deleteProductSettings = deleteProductSettings;
    vm.saveProductSettings = saveProductSettings;
    vm.selectProductType = selectProductType;
    vm.selectProduct = selectProduct;
    vm.toggleEditMode = toggleEditMode;

    vm.$onInit = function () {
      if (vm.mode !== 'create') {
        setProductSettings(vm.productSettings);
      }
    };

    function setProductSettings(clientCommissionProductSettings) {
      vm.productSettings = ClientCommissionProductSettingService.setProductSettings(
        clientCommissionProductSettings,
        vm.priceLists
      );
    }

    function addProductSettings() {
      vm.addMode = true;

      var settingsByPriceList = [];
      vm.priceLists.forEach(function (priceList) {
        settingsByPriceList.push({
          percentage: 0,
          price_list_id: priceList.id,
        });
      });

      vm.productSettings.push({
        product: {},
        settingsByPriceList: settingsByPriceList,
        createMode: true,
      });

      vm.formErrors = false;
    }

    function removeProductSettings(index) {
      vm.mode = 'view';
      vm.addMode = false;

      vm.availableProductsByType = null;

      vm.productSettings.splice(index, 1);
    }

    function deleteProductSettings(productSetting, index) {
      var successCallback = function () {
        removeProductSettings(index);

        vm.onProductSettingsUpdated();
      };

      ClientCommissionProductSettingService.deleteProductSettings(
        productSetting.settingsByPriceList,
        vm.clientId,
        vm.clientCommissionSeasonId,
        successCallback
      );
    }

    // Save settings for products, for all price lists
    function saveProductSettings(productSetting, isProductSettingFormValid) {
      vm.formErrors = false;

      if (!isProductSettingFormValid) {
        vm.formErrors = true;
      } else {
        if (productSetting.editMode) {
          delete productSetting.originalValues;
        }

        vm.mode = 'view';

        vm.sendingForm = true;
        ClientCommissionProductSettingService.saveProductSettings(
          productSetting.settingsByPriceList,
          vm.clientId,
          vm.clientCommissionSeasonId
        ).then(function (response) {
          if (response) {
            // Success
            if (productSetting.createMode) {
              setProductSettings(response);
              productSetting.createMode = false;
            }

            productSetting.editMode = false;

            vm.UtilService.itemListChanged(productSetting.product.id);

            vm.onProductSettingsUpdated();
          } else {
            vm.formErrors = true;
          }

          vm.addMode = false;

          vm.sendingForm = false;
        });
      }
    }

    function selectProductType(productSetting) {
      productSetting.product_id = null;

      var label;

      switch (productSetting.product_type) {
        case 'tour':
          getTours();
          label = 'SELECT_TOUR';
          break;
        case 'transportation':
          getTransportations();
          label = 'SELECT_TRANSPORTATION';
          break;
        case 'hotel':
          getHotels();
          label = 'SELECT_HOTEL';
          break;
        case 'service_item':
          getServiceItems();
          label = 'SELECT_ITEM';
          break;
        case 'package':
          getPackages();
          label = 'SELECT_PACKAGE';
          break;
      }

      vm.productTypeLabel = label;
    }

    function selectProduct(productSetting) {
      // Add values to setting
      productSetting.settingsByPriceList.forEach(function (setting) {
        setting.product_type = productSetting.product_type;
        setting.product_id = productSetting.product_id;
      });
    }

    function getTours() {
      if (vm.tours) {
        getAvailableProductsByType(vm.tours);

        return;
      }

      vm.loadingProducts = true;
      TourService.getTours({ get: 'selector', skip_check_role: true }).then(function (data) {
        vm.tours = data.items;
        getAvailableProductsByType(vm.tours);

        vm.loadingProducts = false;
      });
    }

    function getTransportations() {
      if (vm.transportations) {
        getAvailableProductsByType(vm.transportations);

        return;
      }

      vm.loadingProducts = true;
      TransportationService.getTransportations({ get: 'selector', skip_check_role: true }).then(
        function (data) {
          vm.transportations = data.items;
          getAvailableProductsByType(vm.transportations);

          vm.loadingProducts = false;
        }
      );
    }

    function getHotels() {
      if (vm.hotels) {
        getAvailableProductsByType(vm.hotels);

        return;
      }

      vm.loadingProducts = true;
      HotelService.getHotels({ get: 'selector', skip_check_role: true }).then(function (data) {
        vm.hotels = data.items;
        getAvailableProductsByType(vm.hotels);

        vm.loadingProducts = false;
      });
    }

    function getServiceItems() {
      if (vm.serviceItems) {
        getAvailableProductsByType(vm.serviceItems);

        return;
      }

      vm.loadingProducts = true;
      ServiceItemService.getServiceItems({ get: 'selector', skip_check_role: true }).then(function (
        data
      ) {
        vm.serviceItems = data.items;
        getAvailableProductsByType(vm.serviceItems);

        vm.loadingProducts = false;
      });
    }

    function getPackages() {
      if (vm.packages) {
        getAvailableProductsByType(vm.packages);

        return;
      }

      vm.loadingProducts = true;
      PackageService.getPackages({ get: 'selector', skip_check_role: true }).then(function (data) {
        vm.packages = data.items;
        getAvailableProductsByType(vm.packages);

        vm.loadingProducts = false;
      });
    }

    function getAvailableProductsByType(products) {
      vm.availableProductsByType = [];

      var productSetting, found;

      products.forEach(function (product) {
        found = false;
        for (var j = 0; j < vm.productSettings.length; j++) {
          productSetting = vm.productSettings[j];
          if (product.id === productSetting.product.id) {
            // Found in second array
            found = true;
            break;
          }
        }

        if (!found) {
          vm.availableProductsByType.push(product);
        }
      });
    }

    function toggleEditMode(setting) {
      setting.editMode = !setting.editMode;

      if (!setting.editMode) {
        _restoreOriginalValues(setting);
      } else {
        setting.originalValues = angular.copy(setting);
      }
    }

    // Restore item original values - Edit mode
    function _restoreOriginalValues(setting) {
      setting.settingsByPriceList.forEach(function (priceListSetting) {
        setting.originalValues.settingsByPriceList.forEach(function (originalValue) {
          if (priceListSetting.id === originalValue.id) {
            priceListSetting.percentage = originalValue.percentage;
            return;
          }
        });
      });
    }
  }
})();
